import Image3DPrinting from 'assets/3dprinting.jpg';
import ImageSilicone from 'assets/silicone.jpg';
import ImageInjection from 'assets/injection.webp';
import ImageLaser from 'assets/laser.webp';

export const PROCESSES = {
    '3dprint': {
        name: '3D Printing',
        image: Image3DPrinting,
        materials: {
            'pla': {
                name: 'PLA ⋅ Polylactic Acid',
                description: 'Common, decent strength, rigid, versatile.',
            },
            'abs': {
                name: 'ABS ⋅ Acrylonitrile Butadiene Styrene',
                description: 'Common, tougher, slightly more flexible.'
            },
            'petg': {
                name: 'PETG ⋅ Polyethylene Terephthalate Glycol',
                description: '...',
            },
            'tpu': {
                name: 'TPU ⋅ Thermoplastic Polyurethane',
                description: 'Common, flexible.',
            }
        }
    },
    'laser': {
        name: 'Laser Cut/Engrave',
        image: ImageLaser,
        materials: {
            'mdf_0.25': {
                name: 'MDF ⋅ Medium-Density Fibreboard',
                description: 'Wood fibers adhered together using resin into a single board. Delaminates with excessive ' +
                    'moisture. Decent performance with laser cutting.',
                versions: {
                    '0.25': {
                        name: 'Quarter-Inch (0.25 in, 1/4")',
                    },
                    '0.125': {
                        name: 'Eighth-Inch (0.125 in, 1/8")',
                    }
                }
            }
        }
    },
    'silicone': {
        name: 'Silicone Molding',
        image: ImageSilicone,
        materials: {
            '80a': {
                name: '80A',
                description: 'Strong silicone.'
            }
        }
    },
    'injection': {
        name: 'Injection Molding',
        image: ImageInjection,
        materials: {
            'pla': {
                name: 'PLA ⋅ Polylactic Acid',
                description: '...'
            }
        }
    }
};